import {getAll, validateStatus} from "./helpers";
import axios from "axios/index";
import {SERVICE_URL} from "./constants";

const resource = 'devices';

export function getAllDevicesAPI() {
  return getAll(resource);
}

export function getDevicesByUserId(userId) {
  const typeName = resource + '/owner';
  return axios.get(`${SERVICE_URL}/${typeName}/${userId}`)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.device get by owner, (${typeName}/${userId})] response`, responseData);
      return responseData;
    });
}

export function registerDevice(payload) {
  
  const headers = {'Content-Type': 'application/json'};
  const typeName = resource + '/register';
  
  return axios.put(`${SERVICE_URL}/${typeName}`,
    {payload},
    headers)
    .then(validateStatus(200))
    .then(response => response.data)
    .then(responseData => {
      console.info(`[api.device register device, (${typeName}, ${payload})] response`, responseData);
      return responseData;
    });
}


// WEBPACK FOOTER //
// ./src/api/deviceAPI.js